
export const constant = [
    {
        name:"Job Portal Website",
        tech:"React(Redux), MongoDB, NodeJs",
        weburl:"https://okkjobportal.netlify.app/",
        codeurl:"https://github.com/Oakar-Kyaw/jobportalwebsite",
        description:"A job portal application developed using Redux and React, allowing users to search and apply for jobs, companies to post listings, and administrators to have full control. Utilized MongoDB and Express for storage and server-side implementation, Redux Thunk and Axios for handling API requests, and React components styled with Tailwind CSS for a user-friendly interface."
    },
    {
        name:"Website UI",
        tech:"TailwindCSS",
        weburl:"https://okkgamewebsite.netlify.app/",
        codeurl:"https://github.com/Oakar-Kyaw/gamewebsite",
        description:"Developed a captivating game website using TailwindCSS, featuring a visually appealing and fully responsive UI. Designed with the aesthetics of a gaming tool in mind, creating an immersive experience for users."
    },
    {
        name:"Japanese WordGuess Game",
        tech:"React, Socket.io",
        weburl:"https://japanesewordguessing.netlify.app/",
        codeurl:"https://github.com/Oakar-Kyaw/japanesewordguessing",
        description:"The Multiplayer Japanese Word Guessing Game is a fun and educational game built using React and Tailwind CSS. It features real-time multiplayer functionality, allowing players to compete with each other in guessing Japanese words."
    },
    {
        name:"Mini Restaurant Reservation",
        tech:"Laravel",
        weburl:"https://github.com/Oakar-Kyaw/Restaurant-Reservation",
        codeurl:"https://github.com/Oakar-Kyaw/Restaurant-Reservation",
        description:"Created a restaurant reservations system using Laravel framework, featuring user registration and login functionality. Admin account allows for managing CRUD operations for food items and reservations. Utilized MySQL database for data storage."
    },

]